import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import * as detailsApi from '../api/details';

export const useDetails = (gameId, roundId) => {
  return useQuery({
    queryKey: ['details', gameId, roundId],
    queryFn: () => detailsApi.getDetails(gameId, roundId),
    enabled: !!gameId && !!roundId,
  });
};

export const useAddDetail = (gameId, roundId) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (content) => detailsApi.addDetail(gameId, roundId, content),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['details', gameId, roundId] });
    },
  });
};

export const useConfirmDetail = (gameId, roundId) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (detailId) => detailsApi.confirmDetail(gameId, roundId, detailId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['details', gameId, roundId] });
      queryClient.invalidateQueries({ queryKey: ['influence', 'me', gameId] });
      queryClient.invalidateQueries({ queryKey: ['currentRound', gameId] });
    },
  });
};

export const useCancelDetail = (gameId, roundId) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (detailId) => detailsApi.cancelDetail(gameId, roundId, detailId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['details', gameId, roundId] });
    },
  });
};

export const useSupportDetail = (gameId, roundId) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (detailId) => detailsApi.supportDetail(gameId, roundId, detailId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['details', gameId, roundId] });
      queryClient.invalidateQueries({ queryKey: ['influence', 'me', gameId] });
      queryClient.invalidateQueries({ queryKey: ['currentRound', gameId] });
    },
  });
};

export const useRejectionStatus = (gameId, roundId) => {
  return useQuery({
    queryKey: ['rejection', gameId, roundId],
    queryFn: () => detailsApi.getRejectionStatus(gameId, roundId),
    enabled: !!gameId && !!roundId,
  });
};

export const useToggleRejection = (gameId, roundId) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => detailsApi.toggleRejection(gameId, roundId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['rejection', gameId, roundId] });
      queryClient.invalidateQueries({ queryKey: ['details', gameId, roundId] });
    },
  });
};
